import { backendApi } from "@api/base/backend";

export async function fetchDataAccessTables() {
  const data = await backendApi.callApi(
    "/admin/data/tables",
    "GET"
  );

  return { data };
}

export async function fetchTableDownloadUrl(
  tableName: string,
  limit: number = 10000,
  offset: number = 0,
) {
  const data = await backendApi.callApi([
    "/admin/data/tables",
    `/${tableName}/download`,
    `?limit=${limit}`,
    `&offset=${offset}`,
  ].join(""), "GET");

  return { data };
}

